// RESONATE_HERO_SHOWCASE_V1
// Large product screenshot directly beneath the hero: the Resonate editor with
// AI Assist drafting a post and live AI Critique. Bare app screenshot, so we
// frame it with a rounded border + soft shadow floating on the page background.
import { Reveal } from "@/components/Reveal";

export const HeroShowcase = () => (
  <section data-testid="hero-showcase" className="bg-[#FAFAFF] pt-4 pb-12 md:pb-20">
    <div className="max-w-[1120px] mx-auto px-6">
      <Reveal variant="blur">
        <div className="rounded-2xl overflow-hidden border border-[rgba(38,31,73,0.10)] bg-white shadow-[0_50px_120px_-40px_rgba(38,31,73,0.45)]">
          <img
            src="/brand/product/hero-showcase.png"
            alt="The Resonate editor - AI Assist suggesting alternative hooks on the left while the post draft with live AI Critique and a 7/10 predicted score sits on the right"
            width="1600"
            height="887"
            loading="eager"
            decoding="async"
            className="block w-full h-auto"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
